import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from "@angular/router";
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatInput, MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SigninComponent } from './signin/signin.component';
import { SessionsRoutes } from "./sessions.routing";
import { NotFoundComponent } from './not-found/not-found.component';
import { LoadingComponent } from './loading/loading.component';
 
/*  --- COMPONENTS THAT ARE NO LONGER USED ---- */
import { ErrorComponent } from './error/error.component';
import { LoginComponent } from '../login/login.component';
import { SignupComponent } from './signup/signup.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { SmartSheetService } from 'app/services/smart-sheet-service';
//import { LockscreenComponent } from './lockscreen/lockscreen.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule, MatCardModule, MatProgressBarModule,MatProgressSpinnerModule,MatInputModule,
    //  MatCheckboxModule,
    // MatButtonModule, MatCardModule, MatIconModule,
    // FlexLayoutModule,
    RouterModule.forChild(SessionsRoutes)
  ], providers: [SmartSheetService],
  declarations: [
    SigninComponent, NotFoundComponent, LoadingComponent,  

    //LockscreenComponent,
    LoginComponent, 
    ErrorComponent, 
    SignupComponent, 
    ForgotPasswordComponent, 
  ]
})
export class SessionsModule { }